import { useCommunicationOperations } from './useCommunicationOperations';
import { useEmailOperations } from './useEmailOperations';

export { useCommunicationOperations, useEmailOperations };
